<template>
  <button
    :class="
      `box-border h-10 bg-white border-4 border-${color} disabled:opacity-50 disabled:bg-black`
    "
    v-bind="$attrs"
  >
    <div class="flex flex-row items-center justify-center">
      <edit-wait-icn
        width="20"
        height="20"
        :class="`${color}-icon`"
      ></edit-wait-icn>
      <span :class="`text-${color} text-lg font-bold leading-tight`">
        一時保存
      </span>
    </div>
  </button>
</template>
<script>
import EditWaitIcn from '@/assets/icons/edit-wait.svg?inline'

export default {
  name: 'AppTempSaveBtn',

  components: {
    EditWaitIcn,
  },

  props: {
    color: String,
    colorcode: String,
  },
}
</script>
<style scoped>
button {
  border-radius: 20px;
  width: 180px;
}
</style>
